import classNames from "classnames";
import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

import { DEMO_MODE, DEMO_MODE_DISABLED_TEXT } from "../DemoMode";
import { EditorFileId } from "../gen/ClientState";
import { EditorTab } from "../HexGrip";
import styles from "./EditorTabs.module.css";

export interface EditorTabsProps {
  tabs: EditorTab[];
  activeTab: EditorFileId | null;
  onTabClick: (id: EditorFileId) => void;
  onTabCloseClick: (id: EditorFileId) => void;
}

function EditorTabs(props: EditorTabsProps): JSX.Element {
  return (
    <div className={styles.editor_tabs_cont}>
      {props.tabs.map((tab) => (
        <SingleEditorTab
          key={tab.id}
          active={tab.id === props.activeTab}
          tab={tab}
          onTabClick={() => props.onTabClick(tab.id)}
          onTabCloseClick={() => props.onTabCloseClick(tab.id)}
        />
      ))}
    </div>
  );
}

export interface SingleEditorTabProps {
  active: boolean;
  tab: EditorTab;
  onTabClick: () => void;
  onTabCloseClick: () => void;
}

function SingleEditorTab(props: SingleEditorTabProps): JSX.Element {
  const label = props.tab.filePath !== null ? props.tab.filePath : "Unnamed";

  return (
    <>
      <button
        className={classNames({
          [styles.tab_cont]: true,
          [styles.active]: props.active
        })}
        title={`${props.tab.id}`}
        onClick={props.onTabClick}
      >
        {label}
      </button>
      <button
        className={classNames({
          [styles.tab_close_btn]: true
        })}
        disabled={DEMO_MODE}
        title={DEMO_MODE ? DEMO_MODE_DISABLED_TEXT : undefined}
        onClick={props.onTabCloseClick}
      >
        <AiFillCloseCircle size={22} />
      </button>
    </>
  );
}

export default EditorTabs;
